import React, { useRef, useState, useEffect } from 'react';
import './ImageCarousel.css';
import Papa from "papaparse";

function ImageCarousel() {
  const [data, setData] = useState([]);

  // Sheet: https://docs.google.com/spreadsheets/d/1NlU5y0_CJUBTwTUDEU6tKoFx9zQNXufM2_xQx-qFyAI/edit#gid=0

  useEffect(() => {
    Papa.parse('https://docs.google.com/spreadsheets/d/e/2PACX-1vRbTTGuqFGOC0oToHWGWKqPepKg_8FycINzUbs3Ic2IZX-UbzBOfe3eOa3XpE4LfJ88XAwU5GCjClTX/pub?output=csv', {
      header: true,
      download: true,
      dynamicTyping: true,
      complete: (results) => {
        setData(results.data);
      }
    });
  }, []);
  
  // useEffect(() => {
  //   Papa.parse(
  //     'https://docs.google.com/spreadsheets/d/e/2PACX-1vRbTTGuqFGOC0oToHWGWKqPepKg_8FycINzUbs3Ic2IZX-UbzBOfe3eOa3XpE4LfJ88XAwU5GCjClTX/pub?output=csv',
  //     {
  //       header: true,
  //       download: true,
  //       dynamicTyping: true,
  //       complete: (results) => {
  //         // Reverse the order of the data
  //         const data = results.data.reverse();
  //         setData(data);
  //       },
  //     }
  //   );
  // }, []);


  const imgListRef = useRef(null);

  const scrollRight = () => {
    imgListRef.current.scrollBy({ left: 750, behavior: 'smooth' });
  };

  const scrollLeft = () => {
    imgListRef.current.scrollBy({ left: -750, behavior: 'smooth' });
  };


  return (
    <div className="image-carousel-container">

      {data.length ?
        <div className="image-carousel">
          <button className="image-carousel-btn" id="scroll-left" onClick={scrollLeft}>
            ❮
          </button>
          <ul className="imgList" ref={imgListRef}>
            {data.map((item,index) => {
              return (
                <li className="imgList-item" key={index}>
                  <div className="image-container">
                    <a href={item.ArticleLink} target="_blank" rel="noreferrer">
                      <img
                        src={item.ImageLink}
                        alt="Recent Update"
                      />
                    </a>

                  </div>

                  <div className="image-item-caption">
                    <p>{item.Title}</p>
                  </div>
                </li>
              )
            })}

          </ul>
          <button className="image-carousel-btn" id="scroll-right" onClick={scrollRight}>
            ❯
          </button>
        </div>
        : <p className='Loading-tag'>Loading...</p>}
    </div>
  );
}

export default ImageCarousel;
